module.exports = __webpack_public_path__ + "img/an13.8a3108d5.png";